//---- Automatically generated, don't update this part ----
/**
 * Describes an hospitalisation.
 * Used in reimbursements.
 */

type SourceConceptStringEnum = "GHSM" | "GHSC" | "GHSO" | "DMT";

interface Params {
  sourceConcept: SourceConceptStringEnum;
  sourceValue: string;
  sourceLabel: string;
}

export default class Hospitalisation {
  constructor(params: Params) {
    this.sourceConcept = params.sourceConcept;
    this.sourceValue = params.sourceValue;
    this.sourceLabel = params.sourceLabel;
  }

  toJson() {
    return {
      sourceConcept: this.sourceConcept,
      sourceValue: this.sourceValue,
      sourceLabel: this.sourceLabel
    };
  }

  sourceConcept: SourceConceptStringEnum;

  /**
   * Le code correspond à la nature de l’hospitalisation.
   * Ex : «2727» (pour le type GHS), «156» (pour le type DMT)
   */
  sourceValue: string;

  /**
   * Contient le libellé du code.
   * Ex : «Arthroscopies» (pour 2727), «O.R.L» (pour 156)
   */
  sourceLabel: string;

  //---- End of generated code ----
}
